var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewBusinessicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 147,
    viewBox: "0 0 180 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1866_5300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.3115 83.6235C88.4239 83.6235 107.16 64.9037 107.16 41.8118C107.16 18.7198 88.4239 0 65.3115 0C42.1991 0 23.4628 18.7198 23.4628 41.8118C23.4628 64.9037 42.1991 83.6235 65.3115 83.6235Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.892 156.713V163.474C128.892 165.973 126.971 168 124.61 168H4.28177C1.91313 168 0 165.973 0 163.474V109.689C0 98.0958 8.87826 88.7041 19.8353 88.7041H53.4352C53.8493 88.7041 54.222 88.9606 54.3959 89.3661L64.0526 109.929C64.2183 110.268 64.6738 110.268 64.8311 109.929L74.4962 89.3661C74.6618 88.9606 75.0428 88.7041 75.4569 88.7041H97.6857C94.0168 95.3569 91.9214 103.011 91.9214 111.153C91.9214 133.569 107.773 152.278 128.892 156.713Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.375 152.394C161.291 152.394 179.859 133.842 179.859 110.955C179.859 88.0587 161.291 69.507 138.375 69.507C123.749 69.507 110.887 77.07 103.508 88.5055C99.3255 94.968 96.8989 102.68 96.8989 110.955C96.8989 130.532 110.481 146.941 128.751 151.269C131.84 152.005 135.062 152.394 138.375 152.394ZM138.716 87.7112C139.816 87.7112 140.817 88.3333 141.291 89.311L147.039 101.069L159.886 102.954C160.959 103.114 161.844 103.86 162.183 104.882C162.523 105.904 162.246 107.033 161.477 107.789L152.162 116.952L154.37 129.901C154.549 130.968 154.102 132.043 153.217 132.683C152.332 133.323 151.161 133.394 150.195 132.888L138.725 126.8L127.256 132.888C126.29 133.394 125.119 133.314 124.234 132.683C123.349 132.052 122.902 130.968 123.081 129.901L125.28 116.952L115.965 107.789C115.196 107.033 114.928 105.904 115.258 104.882C115.589 103.86 116.483 103.114 117.556 102.954L130.393 101.069L136.142 89.311C136.624 88.3333 137.617 87.7112 138.716 87.7112Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1866_5300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 168,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBusinessicon);
export default __webpack_public_path__ + "static/media/NewBusinessicon.1c6221b2ee3db6c716542fcaf28b711d.svg";
export { ForwardRef as ReactComponent };